import Vue from 'vue'
import { i18n, translate as $t } from '../language/i18n_mounting' // 多语言


import Router from 'vue-router'
import Layout from '@/components/layout'
import Home from '@/pages/home/index'
import Market from '@/pages/market/index'
import Item from '@/pages/market/item'
import Info from '@/pages/information/index'
import InfoItem from '@/pages/information/item'
import About from '@/pages/information/about'
import Cypher from '@/pages/cypher/index'
import Point from '@/pages/point/index'
import PointItem from '@/pages/point/item'
import Cart from '@/pages/pay/cart'
import Checkout from '@/pages/pay/checkout'
import Pay from '@/pages/pay/pay'
import Message from '@/pages/message/index'
import MessageItem from '@/pages/message/item'
import OrderDetail from '@/pages/order/detail'
import UserLayout from  '@/pages/user/userlayout'
import UserInfo from  '@/pages/user/info'
import Order from  '@/pages/user/order'
import Address from  '@/pages/user/address'
import Exchange from  '@/pages/user/exchange'
import PointChange from  '@/pages/user/point'
import NotFind from '@/components/error'
import UserAgreement from '@/pages/information/useragreement'
import PrivacyAgreement from '@/pages/information/privacyagreement'




Vue.use(Router)
//*******以下为添加内容*******
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
//******以上为添加内容*********
export default new Router({
  routes: [{
      path: '/',
      name: "layout",
      component: Layout,
      children: [
        {
            path: '/',
            name: "home",
            component: Home,
            meta: {
              title: i18n.t('Home')//"首页"
            },
        },
        {
            path: '/market',
            name: "market",
            component: Market,
            meta: {
              title: i18n.t('DakaMarket')//"达咖市场"
            },
        },
        {
            path: '/point',
            name: "point",
            component: Point,
            meta: {
              title: i18n.t('PointsMall')//"积分商城"
            },
        },
        {
            path: '/point/item/:id?',
            name: "pointitem",
            component: PointItem,
            meta: {
              title: i18n.t('PointsMall')//"积分商品详情"
            },
        },
        {
            path: '/cypher',
            name: "cypher",
            component: Cypher,
            meta: {
              title: i18n.t('TradeCards')//"交换卡"
            },
        },
        {
            path: '/market/item/:id?',
            name: "marketitem",
            component: Item,
            meta: {
              title: i18n.t('DakaMarket')//"商品详情"
            },
        },
        {
            path: '/info',
            name: "info",
            component: Info,
            meta: {
              title: i18n.t('DakaNews')//"达咖资讯"
            },
        },
        {
            path: '/info/item/:id?',
            name: "infoitem",
            component: InfoItem,
            meta: {
              title: i18n.t('DakaNews')//"达咖资讯"
            },
        },
        {
            path: '/about',
            name: "about",
            component: About,
            meta: {
              title: i18n.t('AboutUs')//"关于我们"
            },
        },
        {
            path: '/useragreement',
            name: "UserAgreement",
            component: UserAgreement,
            meta: {
              title: "用户协议"
            },
        },
        {
            path: '/privacyagreement',
            name: "PrivacyAgreement",
            component: PrivacyAgreement,
            meta: {
              title: "隐私条款"
            },
        },
        {
            path: '/cart',
            name: "cart",
            component: Cart,
            meta: {
              title: i18n.t('ShoppingCart')//"购物车"
            },
        },
        {
            path: '/checkout/:id?',
            name: "checkout",
            component: Checkout,
            meta: {
              title: "支付"
            },
        },
        {
            path: '/message',
            name: "message",
            component: Message,
            meta: {
              title: i18n.t('Notifications')//"我的消息"
            },
        },
        {
            path: '/message/item/:id?',
            name: "messageItem",
            component: MessageItem,
            meta: {
              title: i18n.t('Notifications')//"消息详情"
            },
        },
        {
            path: '/order/detail/:id?',
            name: "detail",
            component: OrderDetail,
            meta: {
              title: "订单详情"
            },
        },
        {
            path: '/pay/:id?',
            name: "pay",
            component: Pay,
            meta: {
              title: i18n.t('Pay')//"支付"
            },
        },
        {
            path: '/user/info',
            name: "userIndex",
            component: UserLayout,
            children: [
              {
                  path: '/user/info',
                  name: "userIndex",
                  component: UserInfo,
                  meta: {
                    title: i18n.t('AccountInfo')//"个人信息"
                  },
              },
              {
                  path: '/user/order',
                  name: "order",
                  component: Order,
                  meta: {
                    title: i18n.t('OrderHistory')//"我的订单"
                  },
              },
              {
                  path: '/user/address',
                  name: "Address",
                  component: Address,
                  meta: {
                    title: i18n.t('ShippingAddresses')//"收货地址"
                  },
              },
              {
                  path: '/user/exchange',
                  name: "Exchange",
                  component: Exchange,
                  meta: {
                    title: "交换卡兑换"
                  },
              },
              {
                  path: '/user/point',
                  name: "PointChange",
                  component: PointChange,
                  meta: {
                    title: "积分兑换"
                  },
              }
            ]
        },
      ]
    },
    {
      path: '*',
      name: "404",
      component: NotFind,
      meta: {
        title: "404"
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js